'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentVerificationStatus = void 0;
/**
 * Verification status for one single KYC document
 */
var DocumentVerificationStatus;
(function (DocumentVerificationStatus) {
    DocumentVerificationStatus["PENDING"] = "PENDING";
    DocumentVerificationStatus["PROCESSING"] = "PROCESSING";
    DocumentVerificationStatus["APPROVED"] = "APPROVED";
    DocumentVerificationStatus["REJECTED"] = "REJECTED";
})(DocumentVerificationStatus = exports.DocumentVerificationStatus || (exports.DocumentVerificationStatus = {}));
